<template>
<div id="o-app" data-component="LoginRegister.vue" :data-component="(State.CurrentState||{}).PageComponent" :class="{ 'is-desktop': ScreenSize > 1, 'is-modal': isModal, 'a-loaded': true }">
	<LoginPage v-if="CurrentState.LoginPage === 'login' || CurrentState.LoginPage === 'forgot'"/>
	<RegisterPage v-else-if="CurrentState.LoginPage === 'register'" :IsModal="isModal"/>
	<BuyerAuth v-else-if="CurrentState.LoginPage === 'buyer-auth'"/>
</div>
</template>

<script lang="ts">
import { defineAsyncComponent } from 'vue';
import { getAppType, isBuyerApp, isSellerApp } from '@globals/utilities/isMobileApp';

export default {
	name: 'LoginRegister',
	components: {
		LoginPage: defineAsyncComponent(() => import('./LoginPage.vue')),
		RegisterPage: defineAsyncComponent(() => import('./register/RegisterPage.vue')),
		BuyerAuth: defineAsyncComponent(() => import('@buyer/login-register/BuyerAuth.vue')),
	},
	data() {
		return {
			isModal: false,
			debug: '',
		};
	},
	async mounted() {
		if (window.self !== window.top) { this.isModal = true; }
		const appType = await getAppType();
		const buyerApp = await isBuyerApp();
		const sellerApp = await isSellerApp();
		this.debug = `buyer = ${buyerApp}, seller = ${sellerApp}, appType = ${appType}`;

		if (buyerApp && !sellerApp) {
			if (window.location.href.indexOf('ack') > -1) {
				const params = window.location.href.split('ack=')[1].split('&email=');
				window.location.href = `/buyer-app/auth/confirmmailcomplete/?ack=${params[0]}&email=${params[1]}`;
			} else {
				window.location.href = '/buyer-app/auth/login/email';
			}
		}
	},
};

</script>
